// extracted by mini-css-extract-plugin
export default {"filterTag":"FilterTag_filterTag__Y3cQX"};